import { Button, DatePicker, Divider, Form } from 'antd';
import { map } from 'lodash';
import React, { useEffect } from 'react';
import {
  DATE_FORMATS,
  ORDER_TYPE_OPTIONS,
  TRANSFER_ORDER_STATUS,
} from '../../../../../common/constants';
import ModalComponent from '../../../../../components/ModalComponent';
import SelectComponent from '../../../../../components/SelectComponent';
import LibrarySelect from './LibrarySelect';

const { Item } = Form;
const { RangePicker } = DatePicker;

const TransferFilterOrderModal = ({
  isModalOpen,
  setIsModalOpen,
  onFinish,
  finalWhereFilters,
  setFinalWhereFilters,
  transferTypeIn,
}) => {
  const [form] = Form.useForm();

  const handleReset = () => {
    setIsModalOpen(false);
    form?.resetFields();
    setFinalWhereFilters();
    form?.submit();
  };

  useEffect(() => {
    form?.setFieldsValue({
      ...finalWhereFilters,
      status: finalWhereFilters?.status,
      createdAt: [
        finalWhereFilters?.createdAt?.from,
        finalWhereFilters?.createdAt?.to,
      ],
      paidOn: [finalWhereFilters?.paidOn?.from, finalWhereFilters?.paidOn?.to],
    });
  }, [isModalOpen]);

  const orderStatus = map(TRANSFER_ORDER_STATUS, (item) => ({
    label: item?.label,
    value: item?.value,
  }));

  return (
    <>
      <ModalComponent
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        title="Filter"
        forceRender
        destroyOnClose
        footer={null}
      >
        <Divider />
        <div className="mb-16">
          <Form
            form={form}
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
          >
            <Item label="Created At" name="createdAt">
              <RangePicker
                format={DATE_FORMATS?.REGULAR}
                className="full-width"
                popupClassName="picker-with-scroll"
                placeholder={['From Date', 'To Date']}
              />
            </Item>
            <Item label="Status" name="status">
              <SelectComponent
                showSearch={false}
                placeholder="Select Status"
                mode="multiple"
                options={orderStatus}
                maxTagCount={false}
              />
            </Item>
            <Item label="Order Type" name="type">
              <SelectComponent
                showSearch={false}
                placeholder="Select Status"
                mode="single"
                options={ORDER_TYPE_OPTIONS}
                maxTagCount={false}
              />
            </Item>

            <Item label="Owner Library Name" name="ownerLibraryName">
              <LibrarySelect />
            </Item>

            {!transferTypeIn && (
              <Item label="Receiver Library Name" name="receivingLibraryName">
                <LibrarySelect />
              </Item>
            )}
          </Form>
          <div className="d-flex justify-end">
            <Button htmlType="submit" onClick={handleReset} className="mr-8">
              Reset
            </Button>
            <Button key="submit" type="primary" onClick={form?.submit}>
              Apply
            </Button>
          </div>
        </div>
      </ModalComponent>
    </>
  );
};

export default TransferFilterOrderModal;
